import EventTemplateModalView from "./templateModal.html";
import ReportsPreviewModal from "../reports/reports-preview.html";


angular.module("events")

    .controller("EventsListCtrl", ['$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', 'LoginService', '$stateParams', '$state', 'datasetsService', 'treeService', 'logService',
        function ($rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate, LoginService, $stateParams, $state, datasetsService, treeService, logService) {        
            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENTS_WRITE");

            if ($stateParams.is_template == 'true') {
                $rootScope.title = $filter('translate')('events.title_template');
            } else {
                $rootScope.title = $filter('translate')('events.title');
            }

            $scope.dateEvents = {};
            $scope.viewAll = LoginService.permissionExist("P_EVENTS_VIEW_ALL");
            $rootScope.breadcrumb = [
                { title: $filter('translate')('events.title') }
            ];
            $scope.is_template = $stateParams.is_template == 'true';
            $scope.eventFilter = {};

            //$scope.eventFilter.date_from = new Date(); // rodolfo quiere que se lo quite 04/12/2020

            Restangular.all('Mobile/Events/current/access/control').getList().then(function (result) {
                logService.debug(result);
            });
            
            let filter = false;
            if ($rootScope.sizeSm || $rootScope.sizeXs) {
                var maxbottomwidth = 60;
                var titleedit = "";
                var titledelete = "";
                var actionedit = 'popover-placement="top" popover-append-to-body="true" type="button" popover-trigger="mouseenter" uib-popover="' + $filter('translate')('events.button_edit') + '" ui-sref="events.edit({id:row.entity.id, is_template:false})"';
                var actiondelete = 'popover-placement="top" popover-append-to-body="true" type="button" popover-trigger="mouseenter" uib-popover="' + $filter('translate')('events.button_delete') + '"  ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"';
            } else if ($rootScope.sizeLg || $rootScope.sizeMd) {
                var maxbottomwidth = 150;
                var titleedit =" "+ $filter('translate')('events.button_edit');
                var titledelete =" "+ $filter('translate')('events.button_delete')
                var actionedit = 'ui-sref="events.edit({id:row.entity.id, is_template:false})"';
                var actiondelete = 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"';
            }

            if (!$scope.is_template) {
                $scope.options = {
                    date_from: new Date(), _sortBy: 'date_from',
                    required_image: true
                };
                if (!$scope.viewAll) {
                    $scope.options.user_id = LoginService.get("userId");
                }
                $scope.options.is_template = false;
               /* Restangular.all('Events').getList($scope.options).then(function (events) {
                    $scope.events = events;
                });*/
                var optionsPIGa = { entity_type: "events" };
                Restangular.all('InformationsGroups').getList(optionsPIGa).then(function (informationGroups) {
                    $scope.informationGroups = informationGroups;
                    angular.forEach($scope.informationGroups, function (pig) {
                        if (pig.configuration != "") pig.configuration = JSON.parse(pig.configuration);
                    });
                    $scope.checkboxSimpleOptions = [
                        { option: null, label: $filter('translate')('informations.all'), checked: true },
                        { option: true, label: $filter('translate')('events.staff.yes'), checked: false },
                        { option: false, label: $filter('translate')('events.staff.no'), checked: false }
                    ];
                });
            }

            $scope.goToEdit = function (rowEntity) {
                $state.go("events.edit", { group_id: rowEntity.group_id, id: rowEntity.id, is_template: $scope.is_template });
            }

            if (!$scope.is_template) {//Si no es plantilla
                $scope.gridOptionsEvents = {
                    pdfTitle: $filter('translate')('events.pdf_title'),
                    exporterMenuCsv: true,
                    enableGridMenu: true,
                    showTreeExpandNoChildren: false,
                    expandAllRows: false,
                    //gridMenuShowHideColumns: false,
                    enableSorting: true,
                    paginationPageSizes: [20, 40, 60],
                    paginationPageSize: 20,
                    rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                    onRegisterApi: function (gridApi) {
                        this.gridApi = gridApi;
                    },
                    columnDefs: [
                        { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                        {
                            name: 'favourite_to_user', width: 25, field: 'favourite_to_user', displayName: "", enableFiltering: false, enableHiding: false, enableColumnMenu: false,
                            cellTemplate: '<div  class="ui-grid-cell-contents">' +
                                '<a  ng-click="grid.appScope.eventFavourite(row.entity.id)" popover-placement="top" popover-append-to-body="true" popover-trigger="mouseenter" uib-popover="' + $filter('translate')('events.favourite_to_user') + '" ><i class="far fa-star text-primary" ng-if="!row.entity.favourite_to_user" ></i><i class="fa fa-star text-primary" ng-if="row.entity.favourite_to_user" ></i></a>' +
                                '</div>',
                            visible: ($rootScope.sizeSm || $rootScope.sizeXs || $rootScope.sizeMd ? false : true)
                        },
                        {
                            name: 'icon', displayName: $filter('translate')('cms.icon'), cellTemplate: '<div class="ui-grid-cell-contents">' +
                                '<i class="fas fa-{{row.entity.FK_events_events_types.icon}} text-primary m-l-sm" ></i>' +
                                '</div>', width: 80, enableFiltering: false, enableHiding: false
                        },
                        {
                            name: 'is_restricted_access', width: 25, field: 'is_restricted_access', displayName: "", enableFiltering: false, enableHiding: false, enableColumnMenu: false,
                            cellTemplate: '<div  class="ui-grid-cell-contents">' +
                                '<i class="fa fa-lock text-primary" ng-if="row.entity.is_restricted_access" ></i>' +
                                '</div>',
                            visible: ($rootScope.sizeSm || $rootScope.sizeXs || $rootScope.sizeMd ? false : true)                            
                        },
                      {
                          name: 'name', displayName: $filter('translate')('events.name'), enableFiltering: true, enableHiding: false, enableColumnMenu: false, minWidth: 125,
                          cellTemplate: '<div popover-placement="top" popover-append-to-body="true" type="button" popover-trigger="mouseenter" uib-popover="{{grid.getCellValue(row, col)}}"  class="ui-grid-cell-contents">' +
                                                    '<span >{{grid.getCellValue(row, col)}}</span>' +
                                        '</div>'
                      },
                      {
                          name: 'date_from', displayName: $filter('translate')('events.date_from'), maxWidth: 125,minWidth:80,
                          type: 'date', cellFilter: 'toLocalDate | date:\'dd/MM/yyyy\'',
                          customFormatFn: function (value) {
                              if (value != null) {
                                  var fecha = new Date(value);
                                  return $filter('date')(fecha, 'dd/MM/yyyy');
                              }
                              return "";
                          },
                          filterHeaderTemplate: '<div class="ui-grid-filter-container">' +
                              '<input ui-date="{ dateFormat: \'dd/mm/yy\', firstDay: 1, maxDate: grid.appScope.dateEvents.DateTo }" ng-change="grid.appScope.gridOptionsEvents.gridApi.core.raise.itemChanged(grid.appScope);" class="form-control" id="date_init" ng-model="grid.appScope.dateEvents.DateFrom" required>' +
                              '</div>',
                          enableFiltering: true, enableColumnMenu: false
                        },
                        {
                            name: 'pigs', displayName: $filter('translate')('events.pigs'), enableFiltering: false,
                            enableHiding: true, enableColumnMenu: false, enableSorting: false, exporterSuppressExport: false,
                            minWidth: 100, maxWidth: 125,
                            cellTemplate: '<div class="ui-grid-cell-contents">' +
                                ' <span ng-repeat="pinfo in row.entity.information_groups_values track by $index" class="m-l-xs">' +
                                '<span  ng-if="pinfo.FK_information_groups_values_information_groups.type != \'checkboxSimple\' &&pinfo.FK_information_groups_values_information_groups.type != \'datetime\' " popover-placement="top" popover-append-to-body="true" popover-trigger="mouseenter" uib-popover="{{pinfo.FK_information_groups_values_information_groups.name}}: {{pinfo.value}}" class="aColorYellow"><i class="{{pinfo.FK_information_groups_values_information_groups.icon}}"></i></span>' +
                                '<span  ng-if="pinfo.FK_information_groups_values_information_groups.type == \'checkboxSimple\' && pinfo.value !=\'false\'" popover-placement="top" popover-append-to-body="true" popover-trigger="mouseenter" uib-popover="{{pinfo.FK_information_groups_values_information_groups.name}}" class="aColorYellow"><i class="{{pinfo.FK_information_groups_values_information_groups.icon}}"></i></span>' +
                                '<span  ng-if="pinfo.FK_information_groups_values_information_groups.type == \'datetime\'" popover-placement="top" popover-append-to-body="true" popover-trigger="mouseenter"  uib-popover="{{pinfo.FK_information_groups_values_information_groups.name}}: {{ pinfo.value | date : \'dd/MM/yyyy\'}}" class="aColorYellow"><i class="{{pinfo.FK_information_groups_values_information_groups.icon}}"></i></span>' +

                                '</span>' +
                                '</div>',
                            visible: ($rootScope.sizeXs ? false : true)
                        },
                      {
                          name: 'progress', displayName: $filter('translate')('events.progress'), enableFiltering: false,
                          enableHiding: true, enableColumnMenu: false, enableSorting: false, exporterSuppressExport: true,
                          minWidth: ($rootScope.sizeSm || $rootScope.sizeXs || $rootScope.sizeMd ? 50 : 100),
                          maxWidth: ($rootScope.sizeSm || $rootScope.sizeXs || $rootScope.sizeMd ? 50 : 200),
                          cellTemplate: '<div class="ui-grid-cell-contents">' +
                                            '<div class="progress progress-striped" style="background-color: #e6e6e6;">' +
                                                '<div ng-style="{\'width\': row.entity.progress + \'%\'}" class="progress-bar progress-bar-warning">' +
                                                    '<span class="sr-only">{{row.entity.progress}}%</span>'+
                                                '</div>'+
                                            '</div>'+
                              '</div>',
                          visible: ($rootScope.sizeXs  ? false : true)
                      },
                      {
                          name: 'responsible', field: 'FK_events_users.name', displayName: $filter('translate')('events.responsible'), enableFiltering: true, enableHiding: true, enableColumnMenu: false, minWidth: 100, maxWidth: 125,
                          cellTemplate: '<div popover-placement="top" popover-append-to-body="true" type="button" popover-trigger="mouseenter" uib-popover="{{grid.getCellValue(row, col)}}" class="ui-grid-cell-contents">' +
                                                    '<span >{{grid.getCellValue(row, col)}}</span>' +
                              '</div>',
                          visible: ($rootScope.sizeSm || $rootScope.sizeXs ? false : true)
                      },
                      {
                          name: 'guests', displayName: $filter('translate')('events.guests.guests'), enableFiltering: true, enableHiding: false, enableColumnMenu: false, minWidth: 100, maxWidth: 125,
                          cellTemplate: '<div class="ui-grid-cell-contents"><div class="col-sm-1" popover-placement="top" popover-append-to-body="true" popover-trigger="mouseenter" uib-popover="' + $filter('translate')('events.invited') + '">' +
                              '<span class= "label label-small label-default">{{row.entity.totalGuests}}</span></div> <div class="col-sm-1" popover-placement="top" popover-append-to-body="true" popover-trigger="mouseenter" uib-popover="' + $filter('translate')('events.confirmed') + '">' +
                              '<span class="label label-small label-primary">{{row.entity.totalGuestsConfirmed}}</span></div></div> ',
                          visible: ($rootScope.sizeSm || $rootScope.sizeXs ? false : true)
                      },

                        //

                      {
                          name: ' ', minWidth: 50, maxWidth: maxbottomwidth, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionIconNoSpaceTemplate([
                              { title: titleedit, action: actionedit, cssIconClass: "fa fa-edit", cssClass: "btn btn-xs btn-default btn-outline btn-custom-laptop"  },
                              { title: titledelete, action: actiondelete, cssIconClass: "fa fa-remove", cssClass: "btn btn-xs btn-default btn-outline btn-custom-laptop"  }
                          ], { cssClass: "pull-right" })
                      },
                    ],
                    getData: function (options) {
                        options.is_template = angular.isUndefined($scope.is_template);
                        options._sortBy = "date_from";
                        if (filter) {
                            options.name = $scope.eventFilter.name;
                            options.date_from = $scope.eventFilter.date_from;
                            options.date_to = $scope.eventFilter.date_to;
                        }

                        if (!!$scope.dateEvents.DateFrom) options.date_from = $scope.dateEvents.DateFrom;
                        if (!!$scope.dateEvents.DateTo) options.date_to = $scope.dateEvents.DateTo;
                        if (!$scope.viewAll) options.user_id = LoginService.get("userId");
                        var pigs = "";
                        for (var key in $scope.eventFilter.pigs) {
                            if (typeof $scope.eventFilter.pigs[key] != "undefined" && $scope.eventFilter.pigs[key] != "" && $scope.eventFilter.pigs[key] != null) {
                                if (typeof ($scope.eventFilter.pigs[key]) == "object") {
                                    var infoFilter = $scope.informationGroups.filter(function (el) { return el.id == key; });
                                    if(infoFilter.length == 1) {
                                        if (infoFilter[0].type == "datetime") {
                                            if ($scope.eventFilter.pigs[key] != null) pigs += (pigs != "" ? "#" : "") + key + "=>" + new Date($scope.eventFilter.pigs[key]).toISOString();
                                        } else if (infoFilter[0].type == "checkboxSimple") {
                                            if($scope.eventFilter.pigs[key].checked != "") pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.eventFilter.pigs[key].checked;
                                        } else {
                                                pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.eventFilter.pigs[key];
                                        }
                                    }
                                } else {
                                    pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.eventFilter.pigs[key];
                                }
                            }
                        }
                        options.pigs = pigs;
                        //return Restangular.all('Events').getList(options);

                        var deferred = $q.defer();
                        Restangular.all('Events').getList(options).then(function (result) {
                            let data = treeService.eventsTree(result, []);

                            data.totalRows = result.totalRows;
                            deferred.resolve(data);
                        });
                        return deferred.promise;
                    }
                };
            } else { //Si es plantilla
                $scope.gridOptionsEvents = {
                    pdfTitle: $filter('translate')('events.pdf_title'),
                    exporterMenuCsv: true,
                    enableGridMenu: true,
                    //gridMenuShowHideColumns: false,
                    enableSorting: true,
                    paginationPageSizes: [20, 40, 60],
                    paginationPageSize: 20,
                    rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                    onRegisterApi: function (gridApi) {
                        this.gridApi = gridApi;
                    },
                    columnDefs: [
                      { name: 'id', visible: false, enableHiding: false },
                      { name: 'name', displayName: $filter('translate')('events.name'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                      {
                          name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                              { title: $filter('translate')('events.button_edit'), action: 'ui-sref="events.edit({id:row.entity.id, is_template:true})"', cssIconClass: "fa fa-edit" },
                              { title: $filter('translate')('events.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);"', cssIconClass: "fa fa-remove" }
                          ], { cssClass: "pull-right" })
                      },
                    ],
                    getData: function (options) {
                        options.is_template = $stateParams.is_template;
                        options.name = $scope.eventFilter.name;
                        options.date_from = $scope.eventFilter.date_from;
                        options.date_to = $scope.eventFilter.date_to;
                        if (!!$scope.dateEvents.DateFrom) options.date_from = $scope.dateEvents.DateFrom;
                        if (!!$scope.dateEvents.DateTo) options.date_to = $scope.dateEvents.DateTo;
                        if (!$scope.viewAll) options.user_id = LoginService.get("userId");
                        return Restangular.all('Events').getList(options);
                    }
                };
            }

            //set or unset as favourite event
            $scope.eventFavourite = function (event_id) {
                Restangular.all('EventsFavouriteUsers').customPOST({}, "SetOrUnsetFavourite", { event_id: event_id}).then(function (result) {
                    $scope.gridOptionsEvents.loadData(false);
                });

            }

            $scope.searchEvents = function () {
                if (angular.isDefined($scope.gridOptionsEvents.loadData)) {
                    filter = true;
                    $scope.gridOptionsEvents.loadData(false);
                }
            }

            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('events.button_delete'),
                    message: $filter('translate')('events.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('Events', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('events.delete_success'));
                            $scope.gridOptionsEvents.gridApi.core.raise.itemDeleted($scope);
                            Restangular.all('Events').getList($scope.options).then(function (events) {
                                $scope.events = events;
                            });
                        }, function (response) {
                            $scope.errorMessage = response.message;
                        });
                    }
                });

            };

            $scope.templateDialog = function () {
                Restangular.all('Events').getList({ is_template: true }).then(function (templates) {
                    templates.unshift({
                        id: undefined,
                        name: $filter('translate')('events.no_template')
                    })
                    $scope.templates = templates;

                    let $modalInstance = $uibModal.open({
                        animation: true,
                        template: EventTemplateModalView,
                        size: "lg",
                        controller: "TemplateModalCtrl",
                        resolve: {
                            templates: function () { return $scope.templates; }
                        }
                    });
                    //Response del modal
                    $modalInstance.result.then(function (id) {
                        $state.go("events.edit", { id: id, is_template: false });
                    }, function () {
                        console.info('Modal dismissed at: ' + new Date());
                    });
                });

            }

            $scope.export = function () {
                var options = {
                    filters: {
                        NAME: $scope.eventFilter.name,
                        DATE_FROM: $scope.eventFilter.date_from,
                        DATE_TO: $scope.eventFilter.date_to
                    }
                };

                var n = 0;
                for (var key in $scope.eventFilter.pigs) {
                    n++;
                    options.filters["PIG" + n] = "#" + key + "=" + $scope.eventFilter.pigs[key] + "#";
                }

                datasetsService.exportByType("events", options);
            };

        }])
    .controller("TemplateModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', 'templates', function ($scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, templates) {
        $scope.templates = templates;

        $scope.createFromTemplate = function (i) {
            var template = $scope.templates[i];
            if (angular.isDefined(template.id)) {
                Restangular.all("Events/createFromTemplate").post(template).then(function (event) {
                    if (event.id < 1) event.id = undefined;
                    $uibModalInstance.close(event.id);
                });
            }
            else
                $uibModalInstance.close(template.id);
        }

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


    }])


    /***
    * Modal para elegir que tipo de documento imprimir
    ****/
    .controller("ModalGenerateDocumentCtrl", ['Restangular', '$scope', '$uibModalInstance', '$uibModal', '$http', 'options', '$translate', 'logService', function (Restangular, $scope, $uibModalInstance, $uibModal, $http, options, $translate, logService) {
        $scope.orderPrintModal = { _sortBy: "prefered" };
        var optionsValues = { code: options.params.code };
        $http({
            method: 'get',
            url: (window as any).CONFIG.api_url + 'Documents/GetDocumentsByDocumentType',
            params: optionsValues
        }).then(function (results, status, headers, config) {
            $scope.documents = results.data.rows;

            //revisamos los documentos, para quitar los electronicos y marcar como electronicos los normales
            angular.forEach($scope.documents, function (document) {
                logService.debug(document);
            });


            $scope.api_url = (window as any).CONFIG.api_url;
            $scope.type_document = options.params.type_document;
            $scope.type_result = options.params.type_result;
            $scope.showOrder = (options.params.code == "PROPOSAL_GUEST_LIST" ? true : false);//sale la opción de ordenación

            if (options.params.type_result == 'list') {
                $scope.params = options.params.event_id;
            } else if (options.params.type_result == 'list_checked') {
                $scope.params = options.params.event_id + "/" + options.params.event_guests_id;
            } else {
                $scope.params = options.params.event_id + "/" + options.params.id;
            }
            //Con rest, podemos concatenar cualquier cosa. Es cuestion de ponerlo en la llamada así:
            // var params = { event_id: $stateParams.id, code: "EVENT_MENU", type_document: "pdf", type_result: "list", id: "", rest: "/" + menu.id };
            if (angular.isDefined(options.params.rest) && options.params.rest != "") $scope.params = $scope.params + options.params.rest;
        });

        $scope.onAccept = function (document_id, url) {
            if (optionsValues.code == "PROPOSAL_GUEST_LIST") url += "/" + $scope.orderPrintModal._sortBy;
            var data = { document_id: document_id, url: url };
            $uibModalInstance.close(data);
        };
        $scope.onError = function (errorMessage) {
            $uibModalInstance.close(errorMessage);
        };

        $scope.onConfigure = function ($event, document) {
            $event.preventDefault();
            $event.stopPropagation();
            logService.debug(document);

            let $modalInstance = $uibModal.open({
                animation: true,
                template: ReportsPreviewModal,
                controller: 'ReportsPreviewCtrl',
                size: 'lg',
                resolve: {
                    document: function () {
                        return document;
                    },
                    /*event: function () {
                        return {
                            id: options.params.event_id
                        };
                    }*/
                    entity_type: function () { return "events" },
                    entity_type_id: function () { return  options.params.event_id }
                }

            });
            $modalInstance.result.then(function (data) {
                let modified = [];
                //añadimos info de parametros
                angular.forEach(data, function (parameter) {
                    if(typeof parameter.values !== "undefined") {
                        parameter.entity_type = "events";
                        parameter.entity_type_id = $scope.event.id;
                        parameter.document_id = document.id;
                        modified.push(parameter);
                    }
                });

                //guardar parametros para el evento en cuestion
                Restangular.all('DocumentsConfig').post(modified).then(function (data) {
                    logService.debug(data);
                });
            });
        };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])

;
